import { notifications } from '@mantine/notifications';
import { BASE_API_URL } from '@services/config';
import Axios from 'axios';
import cookieUtil from '../cookieUtil';
import VendorUtil from '../vendorUtils';
import getRefreshToken from './getRefreshToken';
import setToken from './setToken';

export const logoutAndRedirect = () => {
  cookieUtil.removeCookie('token');
  cookieUtil.removeCookie('refreshToken');
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.clear();

  const isInBo = window.location.href.includes('/bo');
  if (isInBo) {
    window.location.href = '/bo/auth/login';
  } else {
    // const urlParams = new URLSearchParams(window.location.search);
    // const table = urlParams.get('table');
    // window.location.href = table ? `/?table=${table}` : '/';
  }
};

export const handleTokenRefresh = async () => {
  try {
    const refreshToken = getRefreshToken();
    if (refreshToken) {
      const response = await Axios({
        method: 'POST',
        url: `${BASE_API_URL}api-identity/identity/auth/refreshtoken`,
        headers: {
          'Content-Type': 'application/json',
          hostDomain: VendorUtil.getVendorDomain(),
          domain: VendorUtil.getCurrentConfigDomain(),
        },
        data: {
          refreshToken: getRefreshToken(),
        },
      });
      setToken(response?.data?.data?.token, response?.data?.data?.refreshToken);
      localStorage.setItem('token', response?.data?.data?.token);
      localStorage.setItem('refreshToken', response?.data?.data?.refreshToken);
      notifications.show({
        id: 'refreshToken',
        message: 'توکن شما با موفقیت تمدید شد ، صفحه در حال بارگذاری مجدد...',
        color: 'green',
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      logoutAndRedirect();
    }
  } catch (errorRefresh) {
    logoutAndRedirect();
  }
};
